export const QUAYSO1 = 1
export const QUAYSO2 = 2
export const QUAYSO3 = 3
export const NUMBERGAME1 = 4
export const NUMBERGAME2 = 5
export const KENOSIEUTOC = 6
export const KENOVIETLOTT = 7
export const LODE3MIEN = 8
export const LODESIEUTOC = 9
export const ESPORT = 10
export const VSPORT = 11
export const QUICK_GAME = 12
